import React from "react";
import { SortRadioBtns } from "..";
import "./SortDropdown.css";

function SortDropdown() {
  return (
    <div className="SortDropdown">
      <SortRadioBtns />
    </div>
  );
}

export default SortDropdown;
